/*
import { getGridStringOperators } from "@mui/x-data-grid-premium";

const containsOperator = getGridStringOperators().find((op) => op.value === "contains");

if (!containsOperator) {
  throw new Error("Expected to find the 'contains' grid string operator, but it was undefined.");
}

export const customNotContainsOperator = {
  ...containsOperator,
  label: "does not contain",
  value: "notContains",
  getApplyFilterFn: (filterItem: any, column: any) => {
    if (filterItem.value === undefined || filterItem.value === null) return null;

    const containsFn = containsOperator.getApplyFilterFn(filterItem, column);
    if (!containsFn) return null;

    return (cellValue: any, row: any, col: any, apiRef: any) => !containsFn(cellValue, row, col, apiRef);
  },
};

export const strictEqualsOperator = {
  label: "is exactly",
  value: "equalsStrict",
  getApplyFilterFn: (filterItem: any, _column: any) => {
    if (filterItem.value === undefined || filterItem.value === null || filterItem.value === "") return null;
    return (cellValue: any) => cellValue === filterItem.value;
  },
};

*/

import { Typography } from '@mui/material'
// import { getGridStringOperators } from '@mui/x-data-grid-premium'
// const containsOperator = getGridStringOperators().find(op => op.value === 'contains')

// // Custom operator that wraps the 'contains' logic to invert it
// export const customNotContainsOperator = {
//   ...containsOperator,
//   label: 'does not contain',
//   value: 'notContains',
//   getApplyFilterFn: (filterItem, column) => {
//     if (filterItem.value === undefined || filterItem.value === null) return null

//     const containsFn = containsOperator?.getApplyFilterFn?.(filterItem, column)
//     if (!containsFn) return null

//     return (cellValue, row, column, apiRef) => {
//       // containsFn may accept more args depending on version; forward safely:
//       return !containsFn(cellValue, row, column, apiRef)
//     }
//   },
// }
// export const strictEqualsOperator = {
//   label: 'is exactly',
//   value: 'equals',
//   getApplyFilterFn: filterItem => {
//     if (!filterItem.value) {
//       return null // No filter applied
//     }

//     return cellValue => {
//       return cellValue === filterItem.value // Exact match
//     }
//   },
// }

////////// STRING AVATAR FN ////////////
export const stringAvatar = (name, densityStyles) => {
  // Ensure 'name' is a string, default to an empty string if not
  const validName = typeof name === 'string' ? name : ''

  const nameParts = validName ? validName.split(' ') : ['']

  if (nameParts.length < 2) {
    return {
      children: (
        <Typography
          sx={{
            fontSize: densityStyles?.fontSize ?? 12,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%',
            color: 'text.primary',
          }}
        >
          {nameParts[0][0]}
        </Typography>
      ),
    }
  }
  return {
    children: (
      <Typography
        sx={{
          fontSize: densityStyles?.fontSize ?? 12,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          color: 'text.primary',
        }}
      >
        {`${nameParts[0][0]}${nameParts[1][0]}`}
      </Typography>
    ),
  }
}
